import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import IntegrationInfo from '../IntegrationInfo';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  API_ServiceStandalonePage_Integration,
  gAPI_Ingetration,
  gAPI_Property_List_By_Group,
  dAPI_Delete_Ingetration,
} from '../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import Example from '../Example';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import StandaloneLayout from './StandaloneLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPalette,
  faFont,
  faBorderAll,
  faExternalLinkAlt,
  faRobot,
  faLanguage,
  faFileCode,
  faChartLine,
} from '@fortawesome/free-solid-svg-icons';
import pre_post_form from '../../images/Pre&post_form.png';
import StandaloneDigitalAssistant from './StandaloneDigitalAssistant';
import StandaloneCustomFonts from './StandaloneCustomFonts';
import StandaloneCodeSnippet from './StandaloneCodeSnippet';
import StandaloneServiceAddons from './StandaloneServiceAddons';
import StandaloneLocation from './StandaloneLocation';
import StandaloneExternalLink from './StandaloneExternalLink';
import StandaloneChatBot from './StandaloneChatBot';
import MultliLanguages from './MultliLanguages';
import SEOSettings from './SEOSettings';
import ManageMenu from './ManageMenu';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import digital_guide_book from '../../images/digital_guide_book.png';
import digital_guide_book_language from '../../images/digital_guide_book_language.png';
import Validation from '../../../../../../components/Validation';
import CustomCss from './CustomCss';
import VisitorSettings from './VisitorSettings';
import { faWpforms } from '@fortawesome/free-brands-svg-icons';
import StandaloneGA4Settings from './StandaloneGA4Settings';
function StandAlonePageIntegrationList({ match, history, propertyId, locale }) {
  const integrationId = match.params.id;
  let [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [layoutVisible, setLayoutVisible] = useState(false);
  const [apperanceVisible, setApperanceVisible] = useState(false);
  const [fontsVisible, setFontsVisible] = useState(false);
  const [publishVisible, setPublishVisible] = useState(false);
  const [serviceAddonVisible, setServiceAddonVisible] = useState(false);
  const [botVisible, setBotVisible] = useState(false);
  const [locationVisible, setLocationVisible] = useState(false);
  const [externalLinkVisible, setExternalLinkVisible] = useState(false);
  const [languageVisible, setLanguageVisible] = useState(false);
  const [SEOSettingsVisible, setSEOSettingsVisible] = useState(false);
  const [manageMenuVisible, setManageMenuVisible] = useState(false);
  const [cssVisible, setCssVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [ga4Visible, setGa4Visible] = useState(false);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const setGa4 = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setPublishVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
    setGa4Visible(true);
  };
  const property = () => {
    setPropertyVisible(true);
    setLayoutVisible(false);
    setPublishVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
    setGa4Visible(false);
  };

  const layout = () => {
    setPropertyVisible(false);
    setLayoutVisible(true);
    setPublishVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
    setGa4Visible(false);
  };

  useEffect(() => {
    LoadIntegrationData();
  }, [integrationId]);

  const LoadIntegrationData = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_ServiceStandalonePage_Integration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setIntegration(res.data);
      })
      .catch((err) => console.log('err', err));
  };
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
  }, []);

  const saveIntegration = (data) => {
    const updatedIntegration = {
      ...integration,
    };
    const { list, name } = data;
    if (list === undefined && name === undefined && data) {
      integration.standalonePage = data;
    }
    if (list) {
      integration.properties = data.list;
    }
    if (name) {
      integration.name = name;
    }
    setIntegration(updatedIntegration);

    AxiosAPI({
      method: 'put',
      url: `${API_ServiceStandalonePage_Integration}/${
        integration.id
      }?group_id=${getGroupID()}`,
      data: integration,
    })
      .catch((err) => console.error(err))
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          NotificationManager.success(
            '',
            'integration updated.',
            3000,
            null,
            null,
            'success'
          );
          setTimeout(() => {
            LoadIntegrationData();
          }, 500);
        }
      });
  };

  const RedirectToDemo = () => {
    var url = `${
      process.env.REACT_APP_SERVICE_URL
    }/info?gid=${getGroupID()}&iid=${integrationId}`;
    window.open(url, '_blank');
  };

  const publishCode = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setPublishVisible(true);
    setApperanceVisible(false);
    setFontsVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };

  const appearance = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setPublishVisible(false);
    setApperanceVisible(true);
    setFontsVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };

  const setFonts = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(true);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };
  const setCss = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(true);
    setFormVisible(false);
     setGa4Visible(false);
  };
  const setServiceAddons = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(true);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };
  const setBot = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(true);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };

  const setLocation = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(true);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };
  const ExternalLink = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(true);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };
  const setLanguage = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(true);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };
  const showSEOSettings = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(true);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };

  const chatForm = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(false);
    setCssVisible(false);
    setFormVisible(true);
     setGa4Visible(false);
  };

  const showManageMenu = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setSEOSettingsVisible(false);
    setManageMenuVisible(true);
    setCssVisible(false);
    setFormVisible(false);
     setGa4Visible(false);
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  /** FIXME: */
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
    })
      .then((res) => console.log('res', res))
      .then(
        setTimeout(() => {
          history.push('/app/pages/integration/applications');
        }, 300)
      );
  };

  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/applications' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${
                      propertyVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id="integration.select_properties" />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id="integration.select_properties_enabled" />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      serviceAddonVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-basket-coins`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setServiceAddons()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id="integration.services_addons" />{' '}
                            (Retired)
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id="integration.services_visible" />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      layoutVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-building`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => layout()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Select layout
                          </p>
                          <p className="mb-4 text-small">
                            Select the layout that are visible through this
                            integration
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>

                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      apperanceVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faPalette} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => appearance()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id="integration.appearance" />
                          </p>
                          <p className="mb-4 text-small">
                            Choose your page layout, colors, and fonts
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      manageMenuVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-three-arrow-fork`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showManageMenu()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Manage Menu
                          </p>
                          <p className="mb-4 text-small">
                            Choose the menu items you want to display
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      fontsVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faFont} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setFonts()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Custom Fonts
                          </p>
                          <p className="mb-4 text-small">
                            Upload any custom fonts you might want to use for
                            the page
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      cssVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faFileCode} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setCss()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Custom CSS
                          </p>
                          <p className="mb-4 text-small">
                            Use CSS to customize your Digital Compendium
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      locationVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-location-2`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLocation()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Location
                          </p>
                          <p className="mb-4 text-small">
                            Add your embed location url
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  {/* <div className={`mb-3 integration ${externalLinkVisible ? 'integration--active' : ''}`}>
                    <div className="glyph">
                      <FontAwesomeIcon icon={faExternalLinkAlt} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => ExternalLink()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            External Links
                          </p>
                          <p className="mb-4 text-small">
                            Add your links
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div> */}
                  {/* <div
                    className={`mb-3 integration ${SEOSettingsVisible == true ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faSearch} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showSEOSettings()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            SEO Settings
                          </p>
                          <p className="mb-4 text-small">
                            Boost your voucher store’s SEO with Meta description
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div> */}
                  <div
                    className={`mb-3 integration ${
                      languageVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLanguage()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Language
                          </p>
                          <p className="mb-4 text-small">
                            Select the languages for the chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min  iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      botVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faRobot} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setBot()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Chatbot
                          </p>
                          <p className="mb-4 text-small">
                            Enable your digital assistant
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      formVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faWpforms} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => chatForm()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Pre & Post Chat form
                          </p>
                          <p className="mb-4 text-small">
                            Collect website visitor details, before they can
                            start the chat
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      ga4Visible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faChartLine} className="fa" />
                    </div>

                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setGa4()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Google Analytics Trackings
                          </p>

                          <p className="mb-4 text-small">
                            Track user activity, sessions, and key actions
                            across your app
                          </p>
                        </Colxx>

                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>

                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      publishVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-monitor---tablet`}
                      />
                    </div>

                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => publishCode()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Publish your Digital Compendium
                          </p>
                          <p className="mb-4 text-small">
                            Define SEO settings and create your unique URL
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={RedirectToDemo}
                    >
                      Preview
                    </Button>

                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {apperanceVisible && (
                <Fragment>
                  <StandaloneDigitalAssistant
                    propertyId={propertyId}
                    locale={locale}
                    botSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  <Example url={digital_guide_book} height={'40rem'} />
                </Fragment>
              )}
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  <Example url={digital_guide_book} height={'40rem'} />
                </Fragment>
              )}
              {formVisible && (
                <Fragment>
                  <VisitorSettings
                    integrationId={integration.id}
                    pageSettings={integration.standalonePage.pageSettings}
                    visitor={
                      integration.standalonePage.pageSettings.visitorSettings
                    }
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/popup.png" /> */}
                  <Example url={pre_post_form} />
                </Fragment>
              )}
              {serviceAddonVisible && (
                <Fragment>
                  <StandaloneServiceAddons
                    pageSettings={integration.standalonePage.pageSettings}
                    integrationProperties={integration.properties}
                    saveIntegration={saveIntegration}
                  ></StandaloneServiceAddons>
                  <Example url={digital_guide_book} height={'40rem'} />
                </Fragment>
              )}
              {fontsVisible && (
                <Fragment>
                  <StandaloneCustomFonts
                    botSettings={integration.standalonePage.pageSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  <Example url={digital_guide_book} height={'40rem'} />
                </Fragment>
              )}
              {cssVisible && (
                <Fragment>
                  <CustomCss
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                  ></CustomCss>
                </Fragment>
              )}
              {publishVisible && (
                <StandaloneCodeSnippet
                  propertyId={propertyId}
                  integration={integration}
                  saveIntegration={saveIntegration}
                  integrationProperties={integration.properties}
                />
              )}
              {botVisible && (
                <Fragment>
                  <StandaloneChatBot
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    locale={locale}
                  />
                  <Example url={digital_guide_book} height={'40rem'} />
                </Fragment>
              )}
              {layoutVisible && (
                <Fragment>
                  <StandaloneLayout
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  <Example url={digital_guide_book} height={'40rem'} />
                </Fragment>
              )}
              {locationVisible && (
                <Fragment>
                  <StandaloneLocation
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                  ></StandaloneLocation>
                  <Example url={digital_guide_book} height={'40rem'} />
                </Fragment>
              )}
              {languageVisible && (
                <Fragment>
                  <MultliLanguages
                    botSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                  />
                  <Example url={digital_guide_book_language} height={'40rem'} />
                </Fragment>
              )}
              {ga4Visible && (
                <Fragment>
                  <StandaloneGA4Settings
                    standalonePage={integration.standalonePage}
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                  />
                  
                </Fragment>
              )}
              {/* {externalLinkVisible && (
                <Fragment>
                  <StandaloneExternalLink
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                  ></StandaloneExternalLink>
                  <Example url={digital_guide_book} height={"40rem"} />
                </Fragment>
              )} */}
              {/* {SEOSettingsVisible && (
                <Fragment>
                  <SEOSettings
                    pageSettings={integration.standalonePage.pageSettings}
                    integration={integration}
                    propertyId={propertyId}
                    saveIntegration={saveIntegration}
                  />
                </Fragment>
              )} */}
              {manageMenuVisible && (
                <Fragment>
                  <ManageMenu
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    locale={locale}
                  />
                  <StandaloneExternalLink
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    integrationProperties={integration.properties}
                  ></StandaloneExternalLink>
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(
  connect(mapStateToProps, {})(StandAlonePageIntegrationList)
);
